/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-09-05 14:06:57
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  restart: '重启',
  stop: '停止',
  serviceName: '服务名称',
  status: '状态',
  namespace: '命名空间',
  alertEnabled: '告警开启',
  query: '查询',
  reset: '重置',
  start: '启动',
  application: '所属应用',
});
